<template>
  <div id="baniere">
    <section class="section-shaped my-0 ccc">
      <video autoplay muted loop id="myVideo" class="video">
        <source src="../../../public/img/theme/spot.mp4" type="video/mp4" />
      </video>

      <div class="couverture">
        <div class="shape shape-style-1 shape-dark shape-skew">
        </div>
        <div class="container shape-container d-flex mt-5">
          <div class="col px-0">
            <div class="row">
              <div class="tete" data-aos="zoom-in-up" data-aos-duration="2000">

                <!-- CAROUSEL -->
                <div class="carousel-wrapper">
                  <transition :name="transitionName" mode="out-in">
                    <div class="slide-content" :key="currentSlide">
                      <h1 class="choc text-center text-white">
                        <div class="texte-contour w-full">{{ slides[currentSlide].titleOne }}</div> 
                        <div>
                        <span class="typed-text"> {{ typeValue }}</span>
                        <span class="blinking-cursor">|</span>
                        <span class="cursor" :class="{ typing: typeStatus }"
                          >&nbsp;</span
                        >
                        </div> 
                      </h1>
                      <p class="slide-description text-white mt-3">
                        {{ slides[currentSlide].description }}
                      </p>
                    </div>
                  </transition>

                  <!-- Indicateurs -->
                  <div class="carousel-dots mt-4">
                    <span
                      v-for="(slide, index) in slides"
                      :key="index"
                      class="dot"
                      :class="{ active: currentSlide === index }"
                      @click="goToSlide(index)"
                    ></span>
                  </div>
                </div>
                <!-- FIN CAROUSEL -->

                <!-- <div class="leads text-white mt-4">
                  Publicité à vélo - Activation de marque - Distribution de
                  Flyers et d'objets publicitaire - Porte à Porte - Moving board
                  - Design graphique
                </div> -->

                <div class="btn-wrapper mt-5 text-center button">
                  <base-button
                    class="mb-3 mb-sm-0 btn-lg mr-md-3"
                    type="yellow"
                    @click="$router.push('contact')"
                  >
                    Demander un devis
                  </base-button>
                  <base-button
                    class="mb-3 mb-sm-0 btn-lg btn-outline"
                    type="white"
                    @click="openRdv()"
                  >
                    Planifier un échange
                  </base-button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
  data() {
    return {
      currentSlide: 0,
      transitionName: "slide-fade",
      autoplayInterval: null,
      slides: [
        {
          titleOne: "Panneau Mobile",
          titleTwo: "Publicité Mobile",
          description:
            "Régie publicitaire spécialisée dans les vélos publicitaires, tricycles publicitaires, moving boards et campagnes de proximité partout au Bénin."
        },
        {
          titleOne: "Street Marketing",
          titleTwo: "Activation de Marque",
          description:
            "Distribution de flyers, porte-à-porte, animations commerciales et opérations terrain pour rapprocher votre marque de ses clients."
        },
        {
          titleOne: "Soyez visible",
          titleTwo: "Là où ça compte",
          description:
            "Nous déployons des campagnes de communication à fort impact dans les rues, marchés, quartiers, entreprises et lieux à forte affluence."
        }
      ],
      typeValue: "",
      typeStatus: false,
      typingSpeed: 100,
      erasingSpeed: 150,
      newTextDelay: 5000,
      displayTextArrayIndex: 0,
      charIndex: 0,
      currentText: '',
      timeout: null,
    };
  },
  watch: {
    currentSlide(newVal) {
      this.startTyping();
    }
  },
  created() {
    this.$ga.enable();
    // setTimeout(this.typeText, this.newTextDelay + 200);
    this.startTyping();
    this.startAutoplay();
  },
  beforeDestroy() {
    this.stopAutoplay();
  },
  methods: {
    openRdv(){
      window.open('https://app.iryka.com/r/panneaumobile', '_blank')
    },
    startTyping() {
      clearTimeout(this.timeout); // 🔥 IMPORTANT

      this.currentText = this.slides[this.currentSlide].titleTwo;

      this.typeValue = '';
      this.charIndex = 0;
      this.typeStatus = false;

      this.typeText();
    },
    suivant() {
      this.$emit("oga", true);
    },
    goToSlide(index) {
      this.transitionName = index > this.currentSlide ? "slide-fade" : "slide-fade-reverse";
      this.currentSlide = index;
      this.restartAutoplay();
    },
    nextSlide() {
      this.transitionName = "slide-fade";
      this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextSlide, 8000);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    },
    typeText() {
      if (this.charIndex < this.currentText.length) {
        if (!this.typeStatus) this.typeStatus = true;

        this.typeValue += this.currentText.charAt(this.charIndex);
        this.charIndex++;

        // setTimeout(() => this.typeText(), this.typingSpeed);
        this.timeout = setTimeout(() => this.typeText(), this.typingSpeed);
      } else {
        this.typeStatus = false;
        // setTimeout(() => this.eraseText(), this.newTextDelay);
        this.timeout = setTimeout(() => this.eraseText(), this.newTextDelay);
      }
    },

    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;

        this.typeValue = this.currentText.substring(0, this.charIndex - 1);
        this.charIndex--;

        // setTimeout(() => this.eraseText(), this.erasingSpeed);
        this.timeout = setTimeout(() => this.eraseText(), this.erasingSpeed);
      } else {
        this.typeStatus = false;
        // ❗ On ne fait rien ici → on attend le watcher
      }
    }

  },
};
</script>

<style>
.video {
  min-height: 900px;
  height: 100%;
}
.texte-contour {
  color: transparent; /* Rend le texte sans fond */
  -webkit-text-stroke: 2px rgb(255, 255, 255); /* Ajoute un contour noir de 2px */
  /* text-stroke: 2px rgb(255, 255, 255);  */
  /* Standard (pour compatibilité future) */
}
.ccc {
  background-color: black;
  background-image: url("../../../public/img/theme/woodin/panneau_mobile.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 1100px;
}

/* CAROUSEL */
.carousel-wrapper {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.slide-content {
  text-align: center;
  padding: 0 20px;
}
.choc {
  font-size: 6rem;
  font-weight: bold;
  opacity: inherit;
  line-height: 1.2;
}
.slide-description {
  font-size: 1.2rem;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
  opacity: 0.92;
}

/* Dots */
.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.dot.active {
  background-color: #ffce00;
  transform: scale(1.3);
}

/* Transitions */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.6s ease;
}
.slide-fade-enter {
  opacity: 0;
  transform: translateX(40px);
}
.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-40px);
}
.slide-fade-reverse-enter-active,
.slide-fade-reverse-leave-active {
  transition: all 0.6s ease;
}
.slide-fade-reverse-enter {
  opacity: 0;
  transform: translateX(-40px);
}
.slide-fade-reverse-leave-to {
  opacity: 0;
  transform: translateX(40px);
}

/* BOUTONS */
.leads {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  font-size: 1.1em !important;
}
.couverture {
  background-color: #41ae95d9;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  width: 100%;
  height: 100%;
}
.tete {
  padding-top: 70px;
  width: 100%;
}
.btn-lg:hover {
  color: #ffffff;
}
.btn-outline {
  border: 2px solid #ffffff !important;
  background: transparent !important;
  color: #ffffff !important;
}
.btn-outline:hover {
  background: #ffffff !important;
  color: #41ae95 !important;
}

/* RESPONSIVE */
@media screen and (max-width: 700px) {
  .choc {
    padding-left: 10px;
    padding-right: 10px;
    font-size: 2rem;
    font-weight: bold;
  }
  .slide-description {
    font-size: 1rem;
  }
  .button {
    margin-top: 30px;
  }
  .tete {
    padding-top: 0px;
  }
  .video {
    min-height: 400px;
    max-height: 700px;
  }
  .ccc {
    min-height: 400px;
    max-height: 700px;
  }
  .btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }
}
</style>